export const GLOBAL_RESOURCE_NAMESPACE = '-'
